import * as React from "react";
import styleable from "react-styleable";
import globalStore from "../../stores/GlobalStore";
import * as styles from "./../../../css/components/mainlayout/PortalCollapsibleLanguageField.css";
import Language from "orbiter-core/src/datastructures/languages/Language";
import PortalInput from "./PortalInput";
import { inu, inn } from "orbiter-core/src/basic";
import MultiLanguageString from "orbiter-core/src/datastructures/languages/MultiLanguageString";

class PortalCollapsibleLanguageField extends React.Component<any, any> {
    public constructor(_) {
        super(_);

        // Initial state
        this.state = {open: true};
    }

    public toggle() {
        this.setState({
            open: !this.state.open
        });
    }

    private subrenderLanguages(){
        const languages = globalStore.getLanguages();
        const fields = [];

        if(this.props.multiLanguageString === null)
            return null;

        const multiLanguageString : MultiLanguageString = this.props.multiLanguageString.clone();

        for (let i = 0; i < languages.length; i++){
            const language: Language = languages[i];
            fields.push(<PortalInput key={"descriptioninput" + i} placeholder={language.getDescription()} 
                onChange={(description) => {
                    const mls = multiLanguageString.clone();
                    const inLanguage = mls.getLanguage(language.getIdentifier());
                    inn(inLanguage, a=>a.setValue(description), () => mls.addLanguage(language, description)); // Add if it doesn't exist

                    if(this.props.onChange !== undefined)
                        this.props.onChange(mls);
                }} 
                value={inu(multiLanguageString, (a: MultiLanguageString) => inn(a.getLanguage(language.getIdentifier()), l => l.getValue(), () => ""), ()=>"")}
            />);
        }

        return fields;
    }

    public render() {
        return (
            <fieldset className={styles.portalCollapsibleLanguageField + ' ' + (this.state.open ? styles.open : styles.collapsed)}>
                <legend><a onClick={this.toggle.bind(this)}>{this.props.legend} <span className={this.state.open ? "glyphicon glyphicon-chevron-up" : "glyphicon glyphicon-chevron-down"} aria-hidden="true"></span></a></legend>
                {this.subrenderLanguages()}
            </fieldset>
        );
    }
}
export default styleable(styles)(PortalCollapsibleLanguageField);
